"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.setLocalizationMode = exports.isLocalizationModeEnabled = exports.LOCALIZATION_MODE_COOKIE_NAME = exports.LOCALE_MODE_STEGANOGRAPHY = void 0;
var _universalCookie = _interopRequireDefault(require("universal-cookie"));
var LOCALIZATION_MODE_COOKIE_NAME = exports.LOCALIZATION_MODE_COOKIE_NAME = 'LocalizationMode';
var LOCALE_MODE_STEGANOGRAPHY = exports.LOCALE_MODE_STEGANOGRAPHY = 'steganography';
var isLocalizationModeEnabled = exports.isLocalizationModeEnabled = function isLocalizationModeEnabled() {
  var cookies = new _universalCookie["default"]();
  var localizationMode = cookies.get(LOCALIZATION_MODE_COOKIE_NAME, {
    doNotParse: true
  });
  return (localizationMode === null || localizationMode === void 0 ? void 0 : localizationMode.toLowerCase()) === 'true';
};
var setLocalizationMode = exports.setLocalizationMode = function setLocalizationMode(_ref) {
  var _window;
  var enabled = _ref.enabled,
    demo = _ref.demo;
  var cookies = new _universalCookie["default"]();
  if (enabled) {
    cookies === null || cookies === void 0 || cookies.set(LOCALIZATION_MODE_COOKIE_NAME, 'true', {
      path: '/'
    });
  } else {
    cookies === null || cookies === void 0 || cookies.remove(LOCALIZATION_MODE_COOKIE_NAME, {
      path: '/'
    });
  }
  var currentHref = (_window = window) === null || _window === void 0 || (_window = _window.location) === null || _window === void 0 ? void 0 : _window.pathname;
  if (demo) {
    var _window2;
    (_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.location) === null || _window2 === void 0 || _window2.reload();
  } else {
    window.location.href = "/n.asp?r=".concat(encodeURIComponent(currentHref));
  }
};